export default {"src":"__ASTRO_ASSET_IMAGE__Bz4p$8I___","width":16,"height":16,"format":"svg"}